module.exports = __webpack_public_path__ + "img/norway-flag-round-small.dd7b6fc7.png";